module.exports = __webpack_public_path__ + "static/media/ticket.d7a2cbbe.svg";